// extracted by mini-css-extract-plugin
module.exports = {"categoryHeader":"CategoryHeader_categoryHeader__AF5wR","delineator":"CategoryHeader_delineator__ULnTp","more":"CategoryHeader_more__3S0d4"};